import breather from './../../assets/images/pin_breather3.svg';
import expansive from './../../assets/images/pin_expansive.svg';
import intelligentOffice from './../../assets/images/pin_intelligentoffice3.svg';
import iwg from './../../assets/images/pin_iwg3.svg';
import premier from './../../assets/images/pin_premier.svg';
import servcorp from './../../assets/images/pin_servcorp3.svg';
import executiveCentre from './../../assets/images/pin_theexecutivecentre3.svg';
import ucommune from './../../assets/images/pin_ucommune3.svg';
import wojo from './../../assets/images/pin_wojo3.svg';

import breatherSelected from '../../assets/images/pin_breather_selected.svg';
import convene from '../../assets/images/pin_convene.svg';
import conveneSelected from '../../assets/images/pin_convene_selected.svg';
import executiveCenter from '../../assets/images/pin_executive_center.svg';
import executiveCenterSelected from '../../assets/images/pin_executive_center_selected.svg';
import expansiveSelected from '../../assets/images/pin_expansive_selected.svg';
import HQ from '../../assets/images/pin_HQ.svg';
import HQSelected from '../../assets/images/pin_HQ_selected.svg';
import industrious from '../../assets/images/pin_industrious.svg';
import industriousSelected from '../../assets/images/pin_industrious_selected.svg';
import intelligentOfficeSelected from '../../assets/images/pin_intelligentoffice_selected.svg';
import iwgSelected from '../../assets/images/pin_iwg_selected.svg';
import knotel from '../../assets/images/pin_knotel.svg';
// import novel from '../../assets/images/pin_novel.svg';
import knotelSelected from '../../assets/images/pin_knotel_selected.svg';
import other from '../../assets/images/pin_other providers.svg';
import otherSelected from '../../assets/images/pin_other_selected.svg';
import premierSelected from '../../assets/images/pin_premier_selected.svg';
import regus from '../../assets/images/pin_Regus.svg';
import regusSelected from '../../assets/images/pin_Regus_selected.svg';
import serendipity from '../../assets/images/pin_serendipity.svg';
import serendipitySelected from '../../assets/images/pin_serendipity_selected.svg';
import servcorpSelected from '../../assets/images/pin_servcorp_selected.svg';
import spaces from '../../assets/images/pin_spaces.svg';
import spacesSelected from '../../assets/images/pin_spaces_selected.svg';
import executiveCentreSelected from '../../assets/images/pin_theexecutivecentre_selected.svg';
import ucommuneSelected from '../../assets/images/pin_ucommune_selected.svg';
import wework from '../../assets/images/pin_WeWork.svg';
import weworkSelected from '../../assets/images/pin_WeWork_selected.svg';
import wojoSelected from '../../assets/images/pin_wojo_selected.svg';

export const providericons = [
  { name: 'WeWork', img: wework, imgSelected: weworkSelected },
  { name: 'Convene', img: convene, imgSelected: conveneSelected },
  { name: 'Executive center', img: executiveCenter, imgSelected: executiveCenterSelected },
  { name: 'HQ', img: HQ, imgSelected: HQSelected },
  { name: 'Industrious', img: industrious, imgSelected: industriousSelected },
  { name: 'Knotel', img: knotel, imgSelected: knotelSelected },
  { name: 'Expansive', img: expansive, imgSelected: expansiveSelected },
  { name: 'Regus', img: regus, imgSelected: regusSelected },
  { name: 'Serendipity', img: serendipity, imgSelected: serendipitySelected },
  { name: 'Spaces', img: spaces, imgSelected: spacesSelected },
  {
    name: 'theIntelligentOffice',
    img: intelligentOffice,
    imgSelected: intelligentOfficeSelected,
  },
  { name: 'Iwg', img: iwg, imgSelected: iwgSelected },
  { name: 'Servcorp', img: servcorp, imgSelected: servcorpSelected },
  { name: 'ExecutiveCentre', img: executiveCentre, imgSelected: executiveCentreSelected },
  { name: 'Ucommune', img: ucommune, imgSelected: ucommuneSelected },
  { name: 'Wojo', img: wojo, imgSelected: wojoSelected },
  { name: 'Breather', img: breather, imgSelected: breatherSelected },
  { name: 'Premier', img: premier, imgSelected: premierSelected },
  { name: 'other', img: other, imgSelected: otherSelected },
];
